module.exports = __webpack_public_path__ + "assets/img/Type E (43).c755ad1f.jpg";